import { useExperimentalQuery } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalQuery.ts';
import {
	stringifyPersonalizationAttributes,
	type PersonalizationAttribute,
} from '@confluence/legacy-schema-bridge/entry-points/stringifyPersonalizationAttributes.ts';

import type {
	PersonalizationQuery as PersonalizationQueryData,
	PersonalizationQueryVariables,
} from './useOnboardingEligible/__types__/UserPersonalizationQuery.ts';

interface PersonalizationResponse {
	attributes: PersonalizationAttribute[] | null;
}

export const useExperimentalUserPersonalizationQuery = ({
	skip,
	onError,
	variables,
}: {
	skip?: boolean;
	onError?: (error: Error) => void;
	variables: PersonalizationQueryVariables;
}) => {
	return useExperimentalQuery<
		PersonalizationQueryData,
		PersonalizationQueryVariables,
		PersonalizationResponse
	>({
		url: ({ userId }) => `/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`,
		method: 'GET',
		parseResult: (response: PersonalizationResponse) => ({
			experimentalUserPersonalization: {
				attributes: stringifyPersonalizationAttributes(response.attributes),
			},
		}),
		skip,
		onError,
		variables,
	});
};
